module.exports = __webpack_public_path__ + "img/resource_with_text.2ceb7545.png";